import { useCallback, useEffect, useState } from 'react';
import { getNotificationSoundsWithIds, playNotificationSound } from 'notification-sounds';
import Raven from 'raven-js';
import { useNotificationPreferencesContext } from '../../preferences/NotificationPreferencesContext';
export const useGlobalNotificationSound = () => {
  const {
    playTeaseSound,
    soundId
  } = useNotificationPreferencesContext();
  const [teaseSoundEnabled, setTeaseSoundEnabled] = useState(false);
  const [defaultSoundName, setDefaultSoundName] = useState(null);
  const [globalNotificationSoundDuration, setGlobalNotificationSoundDuration] = useState(0);
  useEffect(() => {
    setTeaseSoundEnabled(playTeaseSound);
    const notificationSounds = getNotificationSoundsWithIds();
    const notificationSound = notificationSounds.find(sound => sound.id === soundId);
    if (notificationSound) {
      setDefaultSoundName(notificationSound.name);
      setGlobalNotificationSoundDuration(notificationSound.duration * 1000);
    } else if (soundId === 0) {
      setDefaultSoundName(null);
      setGlobalNotificationSoundDuration(0);
    } else {
      const fallbackSound = notificationSounds[0];
      setDefaultSoundName(fallbackSound.name);
      setGlobalNotificationSoundDuration(fallbackSound.duration * 1000);
      console.error(`Unknown notification sound id ${soundId}. Falling back to default ${fallbackSound.name}`);
    }
  }, [playTeaseSound, soundId]);
  const playGlobalNotificationSound = useCallback(() => {
    if (!teaseSoundEnabled) {
      return;
    }
    if (defaultSoundName) {
      playNotificationSound(defaultSoundName).catch(e => Raven.captureException(e));
    }
  }, [teaseSoundEnabled, defaultSoundName]);
  return {
    globalNotificationSoundDuration,
    playGlobalNotificationSound
  };
};